import { ThemeProvider } from "@emotion/react"
import theme from "../themes"
import { GlobalStyles } from "@mui/material"

const scrollbarStyles = {
    '*::-webkit-scrollbar': {
        width: '0.5rem'
    },
    '*::-webkit-scrollbar-track': {
        background: theme.palette.common.white,
        borderRadius: '0.25rem'
    },
    '*::-webkit-scrollbar-thumb': {
        background: theme.palette.primary.main,
        borderRadius: '0.25rem'
    },
    '*::-webkit-scrollbar-thumb:hover': {
        background: theme.palette.primary.dark
    }
}

const CustomThemeProvider = ({children}) => {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles styles={scrollbarStyles} />
            {children}
        </ThemeProvider>
    )
}

export default CustomThemeProvider;